import React from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CForm,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CModalFooter,
  CButton,
  CSpinner
} from "@coreui/react";
import { cilCloudDownload, cilDescription } from "@coreui/icons";
import { CIcon } from "@coreui/icons-react";
import i18n from "../../../../i18n";

const checkIsDumpTruck = (dev, vehicleTypes = []) => {
  if (!dev) return false;
  const matchedType = vehicleTypes.find((vt) => vt.id === dev.vehicle_type);
  const typeName = (matchedType?.name || dev.vehicle_type_name || "").toLowerCase();
  const devName = (dev.name || "").toLowerCase();
  return (
    typeName.includes("самосвал") ||
    typeName.includes("dump") ||
    typeName.includes("truck") ||
    devName.includes("самосвал") ||
    dev.vehicle_type === 3
  );
};

const DeviceModals = ({
  t,
  workZones,
  equipmentSpecs,
  vehicleTypes = [],
  modalVisible,
  handleModalClose,
  editingDevice,
  setEditingDevice,
  handleInputChange,
  saving,
  handleSave,
  createModalVisible,
  setCreateModalVisible,
  newDevice,
  setNewDevice,
  handleNewDeviceChange,
  creating,
  handleCreate,

  deleteModalVisible,
  setDeleteModalVisible,
  deviceToDelete,
  deleteConfirmationWord,
  setDeleteConfirmationWord,
  deleting,
  handleDelete,

  passportModal,
  closePassportModal,
}) => {
  const isEditingDumpTruck = checkIsDumpTruck(editingDevice, vehicleTypes);
  const isNewDumpTruck = checkIsDumpTruck(newDevice, vehicleTypes);

  return (
    <>
      {/* 1. МОДАЛЬНОЕ ОКНО РЕДАКТИРОВАНИЯ */}
      <CModal visible={modalVisible} onClose={handleModalClose} alignment="center">
        <CModalHeader onClose={handleModalClose}>
          <CModalTitle>{t("common.edit")}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {editingDevice && (
            <CForm>
              <div className="mb-3">
                <CFormLabel>{i18n.t('device_modals.name', 'Название')}</CFormLabel>
                <CFormInput
                  name="name"
                  value={editingDevice.name || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-3">
                <CFormLabel>{i18n.t('device_modals.vehicle_type', 'Тип техники')}</CFormLabel>
                <CFormSelect
                  name="vehicle_type"
                  value={editingDevice.vehicle_type || ""}
                  onChange={(e) =>
                    setEditingDevice({
                      ...editingDevice,
                      vehicle_type: e.target.value ? parseInt(e.target.value, 10) : null,
                    })
                  }
                >
                  <option value="">-- Не указан --</option>
                  {vehicleTypes.map((vt) => (
                    <option key={vt.id} value={vt.id}>
                      {vt.name}
                    </option>
                  ))}
                </CFormSelect>
              </div>

              <div className="mb-3">
                <CFormLabel>
                  {isEditingDumpTruck ? "{i18n.t('device_modals.body_volume', 'Объем кузова, м³')}" : "{i18n.t('device_modals.bucket_volume', 'Объем ковша, м³')}"}
                </CFormLabel>
                <CFormInput
                  type="number"
                  name="bucket_volume"
                  value={editingDevice.bucket_volume || ""}
                  onChange={handleInputChange}
                  step="0.1"
                  min="0.1"
                />
              </div>

              {!isEditingDumpTruck && (
                <div className="mb-3">
                  <CFormLabel>{i18n.t('device_modals.geometric_volume', 'Геометрический объем, м³')}</CFormLabel>
                  <CFormInput
                    type="number"
                    name="geometric_bucket_volume"
                    value={editingDevice.geometric_bucket_volume || ""}
                    onChange={handleInputChange}
                    step="0.1"
                    min="0.1"
                  />
                </div>
              )}

              <div className="mb-3">
                <CFormLabel>i18n.t('device_modals.fuel_specification', '{i18n.t('device_modals.fuel_specification_short', 'Спецификация расхода топлива')} (Виртуальный расчет)')</CFormLabel>
                <CFormSelect
                  name="equipment_spec"
                  value={editingDevice.equipment_spec || ""}
                  onChange={(e) =>
                    setEditingDevice({ ...editingDevice, equipment_spec: e.target.value })
                  }
                >
                  <option value="">-- Не рассчитывать --</option>
                  {equipmentSpecs?.map((spec) => (
                    <option key={spec.id} value={spec.id}>
                      {spec.model_name} (Х.Х: {spec.rate_idle} | Ср: {spec.rate_medium} | Выс: {spec.rate_high})
                    </option>
                  ))}
                </CFormSelect>
              </div>

              <div className="mb-3">
                <CFormLabel>{i18n.t('device_modals.calibration_coefficient', 'Коэффициент калибровки расхода (K)')}</CFormLabel>
                <CFormInput
                  type="number"
                  name="fuel_k_factor"
                  value={editingDevice.fuel_k_factor || 1.0}
                  onChange={handleInputChange}
                  step="0.01"
                />
              </div>

              <div className="mb-3">
                <CFormLabel>{i18n.t('device_modals.omnicomm_id', 'ID в Omnicomm')}</CFormLabel>
                <CFormInput
                  type="number"
                  name="omnicomm_id"
                  value={editingDevice.omnicomm_id || ""}
                  onChange={handleInputChange}
                  placeholder="Например: 1198021083"
                />
              </div>

              <div className="mb-3">
                <CFormLabel>{i18n.t('device_modals.attach_to_zone', 'Прикрепить к Участку (Объекту)')}</CFormLabel>
                <CFormSelect
                  name="work_zone"
                  value={editingDevice.work_zone || ""}
                  onChange={(e) =>
                    setEditingDevice({
                      ...editingDevice,
                      work_zone: e.target.value,
                    })
                  }
                >
                  <option value="">-- Без привязки --</option>
                  {workZones.map((zone) => (
                    <option key={zone.id} value={zone.id}>
                      {zone.name}
                    </option>
                  ))}
                </CFormSelect>
              </div>
            </CForm>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={handleModalClose}>
            {t("common.cancel")}
          </CButton>
          <CButton color="primary" onClick={handleSave} disabled={saving}>
            {saving ? <CSpinner size="sm" /> : t("common.save")}
          </CButton>
        </CModalFooter>
      </CModal>

      {/* 2. МОДАЛЬНОЕ ОКНО СОЗДАНИЯ */}
      <CModal visible={createModalVisible} onClose={() => setCreateModalVisible(false)} alignment="center">
        <CModalHeader onClose={() => setCreateModalVisible(false)}>
          <CModalTitle>{t("common.add")}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CForm>
            <div className="mb-3">
              <CFormLabel>Название</CFormLabel>
              <CFormInput
                name="name"
                value={newDevice?.name || ""}
                onChange={handleNewDeviceChange}
                placeholder="Введите название"
              />
            </div>

            <div className="mb-3">
              <CFormLabel>Тип техники</CFormLabel>
              <CFormSelect
                name="vehicle_type"
                value={newDevice?.vehicle_type || ""}
                onChange={(e) =>
                  setNewDevice({
                    ...newDevice,
                    vehicle_type: e.target.value ? parseInt(e.target.value, 10) : null,
                  })
                }
              >
                <option value="">-- Не указан --</option>
                {vehicleTypes.map((vt) => (
                  <option key={vt.id} value={vt.id}>
                    {vt.name}
                  </option>
                ))}
              </CFormSelect>
            </div>

            <div className="mb-3">
              <CFormLabel>
                {isNewDumpTruck ? "Объем кузова, м³" : "Объем ковша, м³"}
              </CFormLabel>
              <CFormInput
                type="number"
                name="bucket_volume"
                value={newDevice?.bucket_volume || ""}
                onChange={handleNewDeviceChange}
                step="0.1"
                min="0.1"
              />
            </div>

            {!isNewDumpTruck && (
              <div className="mb-3">
                <CFormLabel>Геометрический объем, м³</CFormLabel>
                <CFormInput
                  type="number"
                  name="geometric_bucket_volume"
                  value={newDevice?.geometric_bucket_volume || ""}
                  onChange={handleNewDeviceChange}
                  step="0.1"
                  min="0.1"
                />
              </div>
            )}

            <div className="mb-3">
              <CFormLabel>Спецификация расхода топлива</CFormLabel>
              <CFormSelect
                name="equipment_spec"
                value={newDevice?.equipment_spec || ""}
                onChange={(e) =>
                  setNewDevice({ ...newDevice, equipment_spec: e.target.value })
                }
              >
                <option value="">-- Не рассчитывать --</option>
                {equipmentSpecs?.map((spec) => (
                  <option key={spec.id} value={spec.id}>
                    {spec.model_name}
                  </option>
                ))}
              </CFormSelect>
            </div>

            <div className="mb-3">
              <CFormLabel>ID в Omnicomm</CFormLabel>
              <CFormInput
                type="number"
                name="omnicomm_id"
                value={newDevice?.omnicomm_id || ""}
                onChange={handleNewDeviceChange}
                placeholder="Например: 1198021083"
              />
            </div>

            <div className="mb-3">
              <CFormLabel>Прикрепить к Участку (Объекту)</CFormLabel>
              <CFormSelect
                name="work_zone"
                value={newDevice?.work_zone || ""}
                onChange={(e) =>
                  setNewDevice({ ...newDevice, work_zone: e.target.value })
                }
              >
                <option value="">-- Без привязки --</option>
                {workZones.map((zone) => (
                  <option key={zone.id} value={zone.id}>
                    {zone.name}
                  </option>
                ))}
              </CFormSelect>
            </div>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="ghost" onClick={() => setCreateModalVisible(false)}>
            {t("common.cancel")}
          </CButton>
          <CButton color="primary" className="fw-bold px-4 text-white" onClick={handleCreate} disabled={creating}>
            {creating ? <CSpinner size="sm" className="me-2" /> : null}
            {t("common.add")}
          </CButton>
        </CModalFooter>
      </CModal>

      {/* 3. МОДАЛЬНОЕ ОКНО УДАЛЕНИЯ */}
      <CModal visible={deleteModalVisible} onClose={() => setDeleteModalVisible(false)} alignment="center">
        <CModalHeader onClose={() => setDeleteModalVisible(false)} className="bg-danger text-white">
          <CModalTitle>{t("common.delete")}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>
            {t("dashboard.confirm_delete")} <strong>{deviceToDelete?.name}</strong>?
          </p>
          <p className="text-danger fw-bold">{i18n.t('device_modals.warning_irreversible', 'ВНИМАНИЕ: Это действие необратимо.')}</p>
          <div className="mb-3">
            <CFormLabel>{i18n.t('device_modals.confirmation_input', 'Для подтверждения введите имя устройства:')}</CFormLabel>
            <CFormInput
              value={deleteConfirmationWord}
              onChange={(e) => setDeleteConfirmationWord(e.target.value)}
              placeholder={deviceToDelete?.name}
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setDeleteModalVisible(false)}>
            {t("common.cancel")}
          </CButton>
          <CButton
            color="danger"
            onClick={handleDelete}
            disabled={deleting || deleteConfirmationWord !== deviceToDelete?.name}
          >
            {deleting ? <CSpinner size="sm" /> : t("common.delete")}
          </CButton>
        </CModalFooter>
      </CModal>

      {/* 4. МОДАЛЬНОЕ ОКНО ТЕХПАСПОРТА */}
      <CModal visible={passportModal?.visible} onClose={closePassportModal} size="xl" alignment="center">
        <CModalHeader closeButton>
          <CModalTitle>{i18n.t('device_modals.technical_passport', 'Технический паспорт')}</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 bg-light" style={{ height: "75vh" }}>
          {passportModal?.loading ? (
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <CSpinner color="primary" />
              <div className="mt-3 text-muted">{i18n.t('device_modals.generating_document', 'Формирование документа...')}</div>
            </div>
          ) : (
            <iframe
              src={passportModal?.url}
              width="100%"
              height="100%"
              title="Предпросмотр паспорта"
              style={{ border: "none" }}
            />
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={closePassportModal}>
            {i18n.t('device_modals.close', 'Закрыть')}
          </CButton>
          {!passportModal?.loading && passportModal?.url && (
            <CButton
              color="primary"
              onClick={() => {
                const a = document.createElement("a");
                a.href = passportModal.url;
                a.download = passportModal.filename;
                a.click();
              }}
            >
              <CIcon icon={cilCloudDownload} className="me-2" />
              {i18n.t('device_modals.download_file', 'Скачать файл')}
            </CButton>
          )}
        </CModalFooter>
      </CModal>
    </>
  );
};

export default DeviceModals;